import { render, staticRenderFns } from "./SVGLayout.vue?vue&type=template&id=f8c6eaf0&scoped=true"
import script from "./SVGLayout.vue?vue&type=script&lang=js"
export * from "./SVGLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c6eaf0",
  null
  
)

export default component.exports